import { Box, Button, Grid, Typography } from '@mui/material';
import AuthCardWrapper from 'views/pages/AuthCardWrapper';
import { TenantSelector, RoleSelector } from '.';
import { useTenantSelector } from 'contexts/TenantSelectorContext';
import useAuth from 'hooks/useAuth';
import Loader from 'ui-component/Loader';
import { LoadingButton } from '@mui/lab';
import { RoleSelectorMode } from '../types';

const TenantSelectorContent = () => {
    const { logout } = useAuth();
    const {
        isLoading,
        hasRedirectPath,
        loadingLogin,
        selectedTenant,
        selectedRole,
        roleSelectorMode,
        handleLogin,
        switchTenantLogin,
        handleClose
    } = useTenantSelector();

    if (isLoading) return <Loader />;

    return (
        <Grid item width="100%" height="100%" p={0} m={0}>
            <AuthCardWrapper>
                <Typography sx={{ pb: '16px', pt: 0, px: '8px' }} fontSize="24px" fontWeight={400}>
                    Access
                </Typography>

                <Box sx={{ height: '100%', maxHeight: 364, overflowY: 'auto', border: '1px solid #D9D9D9', borderRadius: '8px' }}>
                    {roleSelectorMode !== RoleSelectorMode.NONE ? <RoleSelector /> : <TenantSelector />}
                </Box>

                <Grid container spacing={2} justifyContent="flex-end" sx={{ mt: '20px' }}>
                    <Grid item xs="auto">
                        <Button
                            onClick={() => (switchTenantLogin ? handleClose?.() : logout(true))}
                            disabled={loadingLogin}
                            variant="outlined"
                            color="secondary"
                            sx={{ width: '94px', height: '40px' }}
                        >
                            {switchTenantLogin ? 'Cancel' : 'Back'}
                        </Button>
                    </Grid>
                    <Grid item xs="auto">
                        <LoadingButton
                            loading={hasRedirectPath && selectedRole ? true : loadingLogin}
                            onClick={() => handleLogin()}
                            disabled={!selectedTenant || !selectedRole}
                            variant="contained"
                            color="secondary"
                            sx={{ width: '94px', height: '40px' }}
                        >
                            Login
                        </LoadingButton>
                    </Grid>
                </Grid>
            </AuthCardWrapper>
        </Grid>
    );
};

export default TenantSelectorContent;
